




















import Vue from 'vue'

import { ProductCardModel } from '@/search/types'
import { formatOneDecimal } from '@/common/utils/common'

export default Vue.extend({
  props: {
    product: {
      type: Object as () => ProductCardModel,
      required: true
    }
  },
  methods: {
    formatOneDecimal
  }
})
